import React, { Component } from 'react';
import { SvgImage, HtmlComponent } from '../../../components';
import { PropTypes } from 'prop-types';
import { arrowRightIcon, breadcrumIcon } from '../../../../style/images';
import classNames from 'classnames';
import { getRouteToName } from '../../../util';
import $ from 'jquery';

const BreadcrumbChildSelection = ( { active, child, navigateTo } ) => {
  const select = e => navigateTo( e, getRouteToName( child ) );

  return <a onMouseDown={ select } className={ classNames( { active } ) }>
    <HtmlComponent item={ child } />
  </a>;
};

export class BreadcrumbChildSelector extends Component {
  constructor( props ) {
    super( props );
    this.state = {
      active: false
    };
  }

  componentDidMount() {
    this.mounted = true;
  }

  componentWillUnmount() {
    this.mounted = false;
  }

  navigateTo = ( e, urlPath ) => {
    e.stopPropagation();
    this.setState( { active: false } );
    const root = window.location.href.split( '/#' )[0];
    const newLocation = `${root}/#${ urlPath }`;

    if( e.button === 1 ) {
      window.open( newLocation );
      return;
    }

    window.location.href = newLocation;
  }

  toggle = () =>{
    const { active } = this.state;
    this.mounted && this.setState( { active: !active } );
  } 

  hide = () => this.mounted && this.setState( { active: false } );
  
  render() {
    const { children, current } = this.props;
    const { active } = this.state;
    const childComponents = children.filter( child => child ).map( ( child, key ) => 
      <BreadcrumbChildSelection key={ key } active={ current && child.name === current.name } child={ child } navigateTo={ this.navigateTo }/>
    );

    // let activeElement = $('.breadcrumb-child-selector').find('.active')
    // console.log(activeElement.offset())

    return <div 
      tabIndex="-1"
      className="breadcrumb-child-selector" 
      onClick={ this.toggle } 
      onBlur={ this.hide }
    > 
      <SvgImage className={ classNames( { 'active': active } ) } source={ breadcrumIcon } />
      { active && <div className="breadcrumb-child-selector-children">
        { childComponents }
      </div> }
    </div>;
  }
}

BreadcrumbChildSelector.propTypes = {
  children: PropTypes.arrayOf( PropTypes.object ),
  current: PropTypes.shape( {
    name: PropTypes.string
  } )
};